/**
 * SGAMServer
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccountBudgetSummary } from '../model/accountBudgetSummary';
import { AccountRequest } from '../model/accountRequest';
import { AccountRequestErrorModelWithData } from '../model/accountRequestErrorModelWithData';
import { AccountTransactionsSummary } from '../model/accountTransactionsSummary';
import { AccountsTreeNode } from '../model/accountsTreeNode';
import { ErrorModel } from '../model/errorModel';
import { ExpenseTotal } from '../model/expenseTotal';
import { LoansTotal } from '../model/loansTotal';
import { QuickFilters } from '../model/quickFilters';
import { State } from '../model/state';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AccountsService {

    protected basePath = '/SGAM';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsBudgetSummaryGet(projectId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AccountBudgetSummary>>;
    public apiAccountsBudgetSummaryGet(projectId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AccountBudgetSummary>>>;
    public apiAccountsBudgetSummaryGet(projectId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AccountBudgetSummary>>>;
    public apiAccountsBudgetSummaryGet(projectId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AccountBudgetSummary>>('get',`${this.basePath}/api/Accounts/budget/summary`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param stateVersion State version to verfiy application records state
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsDelete(stateVersion: number, id?: string, observe?: 'body', reportProgress?: boolean): Observable<State>;
    public apiAccountsDelete(stateVersion: number, id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<State>>;
    public apiAccountsDelete(stateVersion: number, id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<State>>;
    public apiAccountsDelete(stateVersion: number, id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stateVersion === null || stateVersion === undefined) {
            throw new Error('Required parameter stateVersion was null or undefined when calling apiAccountsDelete.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (stateVersion !== undefined && stateVersion !== null) {
            headers = headers.set('stateVersion', String(stateVersion));
        }

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<State>('delete',`${this.basePath}/api/Accounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsGet(projectId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AccountsTreeNode>>;
    public apiAccountsGet(projectId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AccountsTreeNode>>>;
    public apiAccountsGet(projectId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AccountsTreeNode>>>;
    public apiAccountsGet(projectId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AccountsTreeNode>>('get',`${this.basePath}/api/Accounts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param quickFilters 
     * @param startFrom 
     * @param endAt 
     * @param timezone TimeZone (specified as IANA id) of the client, if not specified, defaults to server&#x27;s timezone
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsIdSummaryGet(id: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'body', reportProgress?: boolean): Observable<AccountTransactionsSummary>;
    public apiAccountsIdSummaryGet(id: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AccountTransactionsSummary>>;
    public apiAccountsIdSummaryGet(id: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AccountTransactionsSummary>>;
    public apiAccountsIdSummaryGet(id: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAccountsIdSummaryGet.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (quickFilters !== undefined && quickFilters !== null) {
            queryParameters = queryParameters.set('quickFilters', <any>quickFilters);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (endAt !== undefined && endAt !== null) {
            queryParameters = queryParameters.set('endAt', <any>endAt);
        }

        let headers = this.defaultHeaders;
        if (timezone !== undefined && timezone !== null) {
            headers = headers.set('timezone', String(timezone));
        }

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AccountTransactionsSummary>('get',`${this.basePath}/api/Accounts/${encodeURIComponent(String(id))}/summary`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param stateVersion State version to verfiy application records state
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsPost(stateVersion: number, body?: AccountRequest, observe?: 'body', reportProgress?: boolean): Observable<State>;
    public apiAccountsPost(stateVersion: number, body?: AccountRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<State>>;
    public apiAccountsPost(stateVersion: number, body?: AccountRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<State>>;
    public apiAccountsPost(stateVersion: number, body?: AccountRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stateVersion === null || stateVersion === undefined) {
            throw new Error('Required parameter stateVersion was null or undefined when calling apiAccountsPost.');
        }


        let headers = this.defaultHeaders;
        if (stateVersion !== undefined && stateVersion !== null) {
            headers = headers.set('stateVersion', String(stateVersion));
        }

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<State>('post',`${this.basePath}/api/Accounts`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param stateVersion State version to verfiy application records state
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsPut(stateVersion: number, body?: AccountRequest, id?: string, observe?: 'body', reportProgress?: boolean): Observable<State>;
    public apiAccountsPut(stateVersion: number, body?: AccountRequest, id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<State>>;
    public apiAccountsPut(stateVersion: number, body?: AccountRequest, id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<State>>;
    public apiAccountsPut(stateVersion: number, body?: AccountRequest, id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stateVersion === null || stateVersion === undefined) {
            throw new Error('Required parameter stateVersion was null or undefined when calling apiAccountsPut.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (stateVersion !== undefined && stateVersion !== null) {
            headers = headers.set('stateVersion', String(stateVersion));
        }

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<State>('put',`${this.basePath}/api/Accounts`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsTotalBudgetSummaryGet(observe?: 'body', reportProgress?: boolean): Observable<Array<AccountBudgetSummary>>;
    public apiAccountsTotalBudgetSummaryGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AccountBudgetSummary>>>;
    public apiAccountsTotalBudgetSummaryGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AccountBudgetSummary>>>;
    public apiAccountsTotalBudgetSummaryGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AccountBudgetSummary>>('get',`${this.basePath}/api/Accounts/total/budget/summary`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param quickFilters 
     * @param startFrom 
     * @param endAt 
     * @param timezone TimeZone (specified as IANA id) of the client, if not specified, defaults to server&#x27;s timezone
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsTotalExpensesGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'body', reportProgress?: boolean): Observable<ExpenseTotal>;
    public apiAccountsTotalExpensesGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExpenseTotal>>;
    public apiAccountsTotalExpensesGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExpenseTotal>>;
    public apiAccountsTotalExpensesGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (quickFilters !== undefined && quickFilters !== null) {
            queryParameters = queryParameters.set('quickFilters', <any>quickFilters);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (endAt !== undefined && endAt !== null) {
            queryParameters = queryParameters.set('endAt', <any>endAt);
        }

        let headers = this.defaultHeaders;
        if (timezone !== undefined && timezone !== null) {
            headers = headers.set('timezone', String(timezone));
        }

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ExpenseTotal>('get',`${this.basePath}/api/Accounts/TotalExpenses`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param quickFilters 
     * @param startFrom 
     * @param endAt 
     * @param timezone TimeZone (specified as IANA id) of the client, if not specified, defaults to server&#x27;s timezone
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAccountsTotalLoansGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'body', reportProgress?: boolean): Observable<LoansTotal>;
    public apiAccountsTotalLoansGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoansTotal>>;
    public apiAccountsTotalLoansGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoansTotal>>;
    public apiAccountsTotalLoansGet(projectId?: string, quickFilters?: QuickFilters, startFrom?: string, endAt?: string, timezone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (quickFilters !== undefined && quickFilters !== null) {
            queryParameters = queryParameters.set('quickFilters', <any>quickFilters);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (endAt !== undefined && endAt !== null) {
            queryParameters = queryParameters.set('endAt', <any>endAt);
        }

        let headers = this.defaultHeaders;
        if (timezone !== undefined && timezone !== null) {
            headers = headers.set('timezone', String(timezone));
        }

        // authentication (Bearer.Google) required
        // authentication (Bearer.Microsoft) required
        // authentication (Bearer.Placeholder) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LoansTotal>('get',`${this.basePath}/api/Accounts/TotalLoans`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
